import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Toggle from '../../../components/Toggle'

import { ReactComponent as PartnerbriteOptimizationIcon } from '../../../assets/icons/partnerbrite-optimization-icon.svg'

import { openForm } from '../../../modules/actions/forms'

import { PARTNERBRAIN_OPTIMISATIONS } from '../../../constants/forms'

import useStyles from './styles'
import { getPartnerbrainName } from '../../helpers/getAppDomainName'

const PartnerbrainToggle = ({ isInitiallyEnabled, onEnableAction }) => {
  const classes = useStyles()

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const partnerbrainName = getPartnerbrainName()

  const [isEnabled, setIsEnabled] = useState(isInitiallyEnabled)

  const onEnableHandler = useCallback(
    e => {
      e.stopPropagation()

      setIsEnabled(prevState => {
        onEnableAction(!prevState)

        return !prevState
      })
    },
    [onEnableAction]
  )

  const onClickHandler = e => {
    if (!isEnabled) {
      onEnableHandler(e)
    } else {
      dispatch(openForm({ formName: PARTNERBRAIN_OPTIMISATIONS }))
    }
  }

  return (
    <div className={classes.container} onClick={onClickHandler}>
      {/*Tooltip appears only when hover container*/}
      <div className={classnames(classes.tooltip, 'tooltip')}>
        <h4 className={classes.tooltipTitle}>
          {t('whatIsPartnerbrain', { partnerbrainName })} <PartnerbriteOptimizationIcon />
        </h4>
        {t('activatePartnerbrainDescription', { partnerbrainName })}
        <span className={classes.tooltipArrow} />
      </div>

      <PartnerbriteOptimizationIcon />
      <span>{t('partnerbrainOptimization', { partnerbrainName })}</span>
      <Toggle isSolid={false} isEnabled={isEnabled} onToggle={onEnableHandler} />
    </div>
  )
}

PartnerbrainToggle.propTypes = {
  isEnabled: PropTypes.bool,
  onEnableAction: PropTypes.func.isRequired
}

export default PartnerbrainToggle
